(function() { module.exports = this["vendor"]; }());


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 34
// module chunks = 0